import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardHeader, CircularProgress, Link, List, ListItem } from "@mui/material";
import { useRootStore } from "../../hooks/useRootStore";
import { useEffect, useState } from "react";
import ChangeErrorCausersDialog from "../ChangeErrorCausersDialog";
import { Employee } from "../../data/Employee";
import { Issue } from "../../data/Issue";
import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";

export default function IssueErrorCausersWidget({ issue }: { issue: Issue }) {
    const { api } = useRootStore();
    const [causers, setCausers] = useState([] as Employee[]);
    const [loading, setLoading] = useState(true);
    const [causersChanging, setCausersChanging] = useState(false);

    useEffect(() => {
        api.getIssueErrorCausers(issue.ID).then(causers => {
            setCausers(causers);
            setLoading(false);
        });
    }, [api, issue])

    return (
        <>
            {causersChanging ? <ChangeErrorCausersDialog issueId={issue.ID} issueState={issue.StateID} errorCausersComment='' onSubmit={(causers: Employee[]) => { setCausers(causers); setCausersChanging(false); } } onCancel={() => setCausersChanging(false)} /> : ''}
            <Card className="issue-widget">
                <CardHeader title="Причины ошибки" className="card-header"/>
                <Box>
                    {loading
                        ?
                            <Box sx={{ textAlign: 'center', p: 5 }}>
                             <CircularProgress />
                            </Box>
                        :
                            <>
                            {causers.length == 0 ?
                                <Box>
                                    <Box sx={{ pb: 2 }}>Нет виновных</Box>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Button size="small" onClick={() => setCausersChanging(true)}>Изменить</Button>
                                    </Box>
                                </Box> :
                                <Accordion sx={{ border: 'none', boxShadow: 'none', p:0 }} >
                                    <AccordionSummary expandIcon={<ArrowDropDownIcon />} sx={{ p:0, boxShadow:'none' }}>
                                        {causers.length} человек(а)
                                    </AccordionSummary>
                                    <AccordionDetails sx={{p:0}} >
                                        <List>
                                            {causers.map(x => <ListItem sx={{p:0, pb:0.5}} key={x.ID}><Link href={`/employees/${x.ID}`}>{x.Name}</Link></ListItem>)}
                                        </List>
                                        <Box sx={{ textAlign:'center' }}>
                                            <Button size="small" onClick={() => setCausersChanging(true)}>Изменить</Button>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            }
                            </>
                    }
                </Box>
            </Card>
        </>
    )
}